export class FileImage extends HTMLElement {
    connectedCallback() {
      this.imageSize         = this.querySelectorAll('[data-element="file-image"]');
      this.imageSizeParent   = document.querySelectorAll('[data-element="file-image-parent"]');
      this._initSizeImages();
    }
    /**
     * INIT SIZES FROM IMAGE
     */
     _initSizeImages() {

      this.imageSizeParent.forEach(function(value, index) {
        let size = value.offsetWidth;
        let imageParent = value.querySelectorAll('img');

        imageParent.forEach(function(valueParent, index) {
          if (size > 0){
            valueParent.setAttribute('sizes', size+'px');
          }
        });
      });

      this.imageSize.forEach(function(value, index) {

        let size = value.offsetWidth;
        let image = value.querySelector('img');
        if (size > 0){
          image.setAttribute('sizes', size+'px');
        }
      });
    }
}

try {
  window.customElements.define('file-image', FileImage);
} catch(e) {}